import { X } from "lucide-react";
import { useEffect, useRef } from "react";

function Modal({ open, setOpen, title, children, containerCls = "" }) {
  const modalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!open) {
    return;
  }

  return (
    <div className="text-gray-700">
      <div className="fixed top-0 left-0 w-screen h-screen z-[99] bg-gray-400 bg-opacity-50 transistion ease-in-out duration-300"></div>

      <div className="fixed top-0 left-0 w-screen h-screen z-[999] transistion ease-in-out duration-300 flex justify-center items-center">
        <div
          className={`min-w-[250px] bg-white rounded-md shadow-md p-4 ${containerCls} max-h-[70vh] overflow-y-auto`}
          ref={modalRef}
        >
          <div className="flex justify-between items-center">
            <div className=" text-xl">{title}</div>

            <button
              className="hover:bg-gray-100"
              onClick={() => setOpen(false)}
            >
              <X />
            </button>
          </div>
          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
